<template>
    <main class="app-container">
        <div :style="`height: ${height}px;`">


            <list-loading v-show="listData.loading && listData.query.page == 1" />
            <div class="no-result" v-show="!listData.loading && listData.data.length < 1">没有记录~</div>
            <md-scroll-view
                    ref="scrollView"
                    :scrolling-x="false"
                    @end-reached="onReachBottom"
            >
                <md-field v-for="item in listData.data"
                          :key="item.id"
                          :title="item.type">
                    <md-detail-item title="数量" :content="(item.action == 1 ? '+ ' : '- ') + item.amount" />
                    <md-detail-item title="课包类型" :content="item.bundle_type" />
                    <md-detail-item title="发生时间" :content="`${item.created_at}`" />
                </md-field>

                <md-scroll-view-more
                        slot="more"
                        finished-text=""
                        :is-finished="listData.hasNextPage == false"
                >
                </md-scroll-view-more>
            </md-scroll-view>
        </div>


        <md-landscape v-model="showFullScreen" full-screen>
            <enroll-detail></enroll-detail>
        </md-landscape>
    </main>
</template>

<script>
import { Field, DetailItem,Landscape,ScrollView, ScrollViewMore } from 'mand-mobile'
import EnrollDetail from "../components/EnrollDetail.vue";
import ListLoading from "../components/ListLoading.vue";
import listDataMixin from "../mixins/list-data";

export default {
    name: "course-bundle-log",
    components: {
        [Field.name]: Field,
        [DetailItem.name]: DetailItem,
        [Landscape.name]: Landscape,
        [ScrollView.name]: ScrollView,
        [ScrollViewMore.name]: ScrollViewMore,
        EnrollDetail,ListLoading,
    },
    mixins: [listDataMixin],

    data() {
        return {
            apiEndpoint: 'course-bundle-logs',
            showFullScreen:false,
            height: window.screen.height,
        }
    },
    methods: {

    },
    created() {
        this.loadListData();
    },
};
</script>


<style lang="scss" scoped>
.md-field{
    margin-bottom: 20px;
}

</style>
